import { IContextMenuPosition } from '@pressreader/popups-types';
import type { PopupContainerDynamicSizePositionCalculationStrategy } from '@pressreader/ui-popups';

enum PopupType {
    ContextMenu,
    Dialog,
}

interface IPopup<TType = PopupType, TContext = unknown> {
    type: TType;

    id: string;

    name: string;

    context: TContext;
}

interface IContextMenuPopup<TContext> extends IPopup<PopupType.ContextMenu, TContext> {
    /** Parent ContextMenu Id */
    parentId?: string;

    position: IContextMenuPosition;

    /**
     * Defines the strategy for calculating the position and size of the popup.
     * Works only for dynamic size popups.
     */
    positionCalculationStrategy?: PopupContainerDynamicSizePositionCalculationStrategy;
}

interface IDialogPopup<TContext> extends IPopup<PopupType.Dialog, TContext> {
    supportNativeScroll: boolean;
}

type AnyPopup = IContextMenuPopup<unknown> | IDialogPopup<unknown>;

export { AnyPopup, PopupType, IContextMenuPopup, IDialogPopup };
